import { useEffect, useRef } from 'react';
import { useAppStore } from '@/state/store';

const GLYPH: Record<string, string> = {
  info: '›',
  success: '✓',
  warning: '!',
  error: '✕',
};

export function StatusConsole() {
  const status = useAppStore((s) => s.status);
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [status.length]);

  return (
    <div className="status-console" ref={scrollRef} aria-live="polite">
      {status.map((entry) => (
        <div key={entry.id} className={`status-line level-${entry.level}`}>
          <span className="status-glyph">{GLYPH[entry.level]}</span>
          <span className="status-text">{entry.message}</span>
        </div>
      ))}
    </div>
  );
}
